export const portfolioData = {
  "website-projects": {
    "slug": "website-projects",
    "title": "Website Projects",
    "heroBg": "/assets/images/photo-1544383835-bda2bc66a55d.jpg",
    "overview": "A showcase of our recent website design and development projects, featuring responsive layouts, custom e-commerce stores, and high-performance corporate platforms.",
    "projects": [
      {
        "title": "Corporate E-Commerce Portal",
        "category": "Web Development",
        "image": "/assets/images/photo-1460925895917-afdab827c52f.jpg"
      },
      {
        "title": "Real Estate Listing Platform",
        "category": "Web Design & Development",
        "image": "/assets/images/photo-1558494949-ef010cbdcc31.jpg"
      }
    ]
  },
  "mobile-apps": {
    "slug": "mobile-apps",
    "title": "Mobile Apps",
    "heroBg": "/assets/images/photo-1451187580459-43490279c0fa.jpg",
    "overview": "Explore our mobile applications developed for iOS and Android, delivering seamless user experiences and robust functionality for businesses on the go.",
    "projects": [
      {
        "title": "On-Demand Delivery App",
        "category": "iOS & Android",
        "image": "/assets/images/photo-1544383835-bda2bc66a55d.jpg"
      },
      {
        "title": "Fitness Tracking Platform",
        "category": "React Native",
        "image": "/assets/images/photo-1460925895917-afdab827c52f.jpg"
      }
    ]
  },
  "software-solutions": {
    "slug": "software-solutions",
    "title": "Software Solutions",
    "heroBg": "/assets/images/photo-1558494949-ef010cbdcc31.jpg",
    "overview": "View our custom enterprise software solutions, including CRMs, ERPs, and automated workflow systems designed to streamline business operations.",
    "projects": [
      {
        "title": "Enterprise CRM Dashboard",
        "category": "Custom Software",
        "image": "/assets/images/photo-1451187580459-43490279c0fa.jpg"
      },
      {
        "title": "Automated HR & Payroll System",
        "category": "Enterprise Solutions",
        "image": "/assets/images/photo-1544383835-bda2bc66a55d.jpg"
      }
    ]
  }
};
